import { helper } from '@ember/component/helper';
import { assert } from '@ember/debug';

export default helper(function gte([num1, num2] /*, named*/) {
  if (isNaN(+num1) || isNaN(+num2)) {
    assert('Please ensure both arguments are numbers');
  }
  return num1 >= num2;
});
